import * as React from "react";

export const useScrollToTop = () => {
  React.useEffect(() => {
    const isInIframe = window.self !== window.top;
    if (isInIframe) {
      window.parent.postMessage(
        {
          type: "settld:scrollToIframeTop",
        },
        "https://www.settld.care/"
      );
    }
    setTimeout(() => {
      window.scrollTo({ top: 0, left: 0, behavior: "auto" });
    });
  }, []);
};
